import { objectEntries, objectFromEntries, removeNullUndefined } from "@nens/shared-utils";

// This helper is used to remove empty string, null and undefined values from query keys,
// as these can cause unnecessary cache misses in react-query.
// For example:
// { broId: "" }, { broId: undefined }, { page: 1 } and { broIdContains: "" } are all essentially the same query,
// as they all represent a query without a filter. However, if we include these values in the query key,
// react-query will treat them as different queries and will not use the cached data when it should.
// By simplifying the query parameters to remove these values,
// we can ensure that react-query correctly identifies when two queries are the same and can use the cached data.
export const simplifyQueryParam = <T>(param: T): T => {
  if (!param || typeof param !== "object" || Array.isArray(param)) return param;

  return objectFromEntries(
    removeNullUndefined(
      objectEntries(param).map(([key, value]) => {
        if (value === "" || value === undefined || value === null) return null;
        if (key === "page" && value === 1) return null; // Remove page=1 as it's the default and doesn't need to be in the query key
        return [key, value];
      })
    )
  ) as T;
};
